import axios from "axios";

const hasEnv = <T>(conf: T): conf is T & { _env: unknown } =>
  typeof conf === "object" && conf !== null && "_env" in conf;

const isEnv = (env: unknown): env is { API_URL: string } =>
  typeof env === "object" && env !== null && "API_URL" in env;

function getApiUrl<T>(config: T): string {
  if (typeof config === "string") return config;
  if (!hasEnv(config) || !isEnv(config._env)) {
    throw new Error("Configuration is Missing");
  }
  return config._env.API_URL;
}

export function makeUrlConfig(API_URL: string) {
  return { _env: { API_URL } };
}

export function buildClient(config: unknown = window) {
  const client = axios.create({
    headers: { "Content-Type": "application/json" },
    baseURL: getApiUrl(config),
  });

  client.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      return Promise.reject(error.response || error.Detail);
    }
  );
  return client;
}
